import { HomePage } from '@cannect/pages/Home'
import Cuida from 'pages/Cuida'
import { RedirectToWeightLossProgram, WeightLossProgram } from 'pages/WeightLossProgram'
import { PAGE_PATH, PAGE_PATH_LEGACY, PROGRAM_TRAIL_LEGACY_PATH } from 'pages/WeightLossProgram/constants'
import { RedirectLegacyProgramTrail } from 'pages/WeightLossProgram/trail'
import CommonQuestions from 'pages/CommonQuestions'
import HealthProfessionals from 'pages/HealthProfessionals'
import { NewBlog } from 'pages/NewBlog'
import Partners from 'pages/Partners'
import PatientHome from 'pages/PatientHome'
import RealStories from 'pages/RealStories'
import { Screening } from 'pages/Screening'
import Treatment from 'pages/Treatments/Treatment'
import { useEffect, useMemo } from 'react'
import { Route as PublicRoute, useLocation } from 'react-router-dom'
import Route from 'routes/Route'
import { IChildTypes } from 'types/ChildrenTypes'
import { useBrand } from '../../hooks/useBrand'
import useScrool from '../../hooks/useScrool'
import { RoutePatientOrDoctor } from '../../routes/PrivateRoutes'
import Footer from '../Footer'
import * as Style from './styles'
import CannectCode from '@cannect/pages/CannectCode'

function Layout({ children }: IChildTypes) {
  const { pathname } = useLocation()
  const { ref, handleScrollTop } = useScrool()
  const { config } = useBrand()

  useEffect(() => {
    if (pathname.indexOf('/produtos/1')) handleScrollTop()
  }, [pathname])

  const isDigitalJourneyFlow = useMemo(() => pathname.includes('jornada-digital'), [pathname])
  const isWeightLossLanding =
    pathname === PAGE_PATH || pathname === PAGE_PATH_LEGACY || pathname.startsWith(PROGRAM_TRAIL_LEGACY_PATH)
  const applyMaxWidthExeptions = ['/agendamento', 'login', '/onboarding-calendar', '/curadoria', '/detalhes-produtos']
  const shouldShowFooter = !isDigitalJourneyFlow && !isWeightLossLanding && config.features.showFooter

  return (
    <Style.Container ref={ref} id="main-app-container" $flushTop={isWeightLossLanding}>
      <Style.Wrapper id="page-wrapper" vaul-drawer-wrapper="" $flushTop={isWeightLossLanding}>
        <Route path="/" exact component={HomePage} />
        <Route path="/blog" exact component={NewBlog} />
        <Route path="/tratamentos/:slug" exact component={Treatment} />
        {/*   <Route path="/teste-genetico" exact component={CannectGene} /> */}
        <Route path="/perguntas-frequentes" exact component={CommonQuestions} />
        <Route path="/area-profissionais" exact component={HealthProfessionals} />
        <Route path="/triagem" component={Screening} />
        <Route path="/area-parceiros" exact component={Partners} />
        <Route path="/comunidade" exact component={RealStories} />
        <Route exact path="/teste-genetico" component={CannectCode} />
        <RoutePatientOrDoctor path="/area-paciente" exact component={PatientHome} />
        <Route path="/cuida" exact component={Cuida} />
        <Route path={PAGE_PATH_LEGACY} exact component={RedirectToWeightLossProgram} />
        <PublicRoute exact path={`${PROGRAM_TRAIL_LEGACY_PATH}/:step?`} component={RedirectLegacyProgramTrail} />
        <Route path={PAGE_PATH} exact component={WeightLossProgram} />
        <Style.PagesWrapper
          applyMaxWidth={!applyMaxWidthExeptions.includes(pathname)}
          fullHeight={pathname.includes('jornada-digital')}>
          {children}
        </Style.PagesWrapper>
        {shouldShowFooter && <Footer />}
      </Style.Wrapper>
    </Style.Container>
  )
}

export default Layout
